module.exports = __webpack_public_path__ + "images/262358449fca6faa7794e6ce15cc04ab.svg";